// VehInfoNarrowList.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { IconButton } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import FlexyTable from '../common/flexytable/FlexyTable';
import { TableColumnType } from '../../model/AppConst';
import styled from '@emotion/styled';
import { ContentHeader, HeaderLeft } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';

const TableColumns = [
	{ id: 'vehPlates', label: '차량번호', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
	{ id: 'vehAlias', label: '지도표시명', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
	{ id: 'gpsTime', label: '최종보고', width: 180, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} },
	{ id: 'distKm', label: '누적거리', width: 100, show: true, option:{align: 'right', type: TableColumnType.INTEGER} },
    { id: 'vehTypeTon', label: '차종-톤수', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
	{ id: 'termId', label: '단말기번호', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'vehAddr', label: '차고지', width: 100, show: false, option:{align: 'inherit', type:TableColumnType.TEXT} },
	{ id: 'driverName', label: '기사', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
	{ id: 'driverMobile', label: '휴대전화', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'termPowerValue', label: '전원공급방식', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
    { id: 'useYn', label: '사용여부', width: 100, show: true, option:{align: 'center', type:TableColumnType.CHAR, ynBoolean: ['사용 중','사용중지']} },
    { id: 'termEtc', label: '비고(단말기)', width: 300, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
    { id: 'custName', label: '운송사', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} }, // VEH_AND_TERM
];

const VehInfoListContainer = styled(Box)({
    flexGrow:1, display:'flex', flexDirection:'column'
});

const ColumnVehPlates = 'vehPlates';

export default function VehInfoNarrowList({
    itemSelected,
    columnList,
    onClickItem,
    records,
    tools,
    onRequestReload
}) {
    const [columns, setColumns] = useState([ColumnVehPlates]);
    const [search, setSearch] = useState('');

    useEffect(()=>{
        const newCols = [];
        for(const col of TableColumns) {
            if(columnList.includes(col.id)) {
                newCols.push(col);
            }
        }
        if(newCols.length===0) newCols.push(ColumnVehPlates);
        setColumns(newCols);
    }, [columnList]);

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    return(
        <VehInfoListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <SearchBox onChange={onChangeSearch} value={search} width={160}/>
                </HeaderLeft>
                {
                    onRequestReload &&
                    <IconButton
                        onClick={onRequestReload}
                        style={{marginLeft: 10}}
                    >
                        <ReplayIcon />
                    </IconButton>
                }
            </ContentHeader>
            <FlexyTable
                name="veh_info_narrow_list"
                uniqueKey="vehId"
                columns={columns}
                records={records}
                selected={itemSelected ? [itemSelected] : null}
                onClickOneRow={onClickItem}
                search={search}
                tools={tools ? tools : []}
                hideFirstTopButton={true}
                defaultSorter={{id:'vehPlates', type: TableColumnType.TEXT}}
            />
        </VehInfoListContainer>
    );

}

